module.exports = __webpack_public_path__ + "img/users-1.8d15f1e7.svg";